import { render } from "./FpuiTableHeader.vue?vue&type=template&id=d38fa950"
import script from "./FpuiTableHeader.vue?vue&type=script&lang=js"
export * from "./FpuiTableHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__